import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UAParser from 'ua-parser-js';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons/faShareAlt';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import handlePost from './utils/facebook';
import handleTweet from './utils/twitter';
import throttle from 'lodash/throttle';

const uaParser = new UAParser();
const getMetaContent = (property) => {
  const el = document.querySelector(`meta[property="${property}"]`);
  if (el) return el.getAttribute('content');
  return '';
};

const ShareButtons = (props) => {
  const [lastScroll, setLastScroll] = useState(0);
  const [showShare, setShowShare] = useState(false);
  const [showSecondaryDialogue, setShowSecondaryDialogue] = useState(false);

  function handleScroll() {
    if (lastScroll > window.scrollY) {
      if (!showShare) {
        setShowShare(true);
      }
    } else {
      if (showShare) {
        if (showSecondaryDialogue) {
          setShowSecondaryDialogue(false);
        } else {
          setShowShare(false);
        }
      }
    }
    setLastScroll(window.scrollY);
  }

  const handleShare = async function() {
    if (showSecondaryDialogue) {
      setShowSecondaryDialogue(true);
      return;
    }
    if (
      navigator &&
      navigator.share &&
      uaParser.getBrowser().name !== 'Safari'
    ) {
      try {
        await navigator.share({
          title: getMetaContent('og:title'),
          text: getMetaContent('og:description'),
          url: window.location.href,
        });
      } catch (err) {
        console.log('Share error', err);
      }
    // Otherwise copy URL to a clipboard
    } else {
      setShowSecondaryDialogue(true);
    }
  };

  const scroll = throttle(handleScroll, 250);

  useEffect(() => {
    window.addEventListener('scroll', scroll);
    return () => window.removeEventListener('scroll', scroll);
  }, [scroll]);

  return (
    <div className={classnames(component)}>
      <div className={classnames('sharetool', { active: showShare })}>
        <div className={classnames('drawer', { active: showSecondaryDialogue })}>
          <button
            title='Share this!'
            disabled={showSecondaryDialogue}
            className='box-shadow-low'
            onClick={async() => await handleShare()}
          >
            <FontAwesomeIcon fw icon={faShareAlt} />
          </button>
          <button onClick={handleTweet} title='Twitter'>
            <FontAwesomeIcon fw icon={faTwitter} />
          </button>
          <button onClick={handlePost} title='Facebook'>
            <FontAwesomeIcon fw icon={faFacebookF} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareButtons;
